import React from "react";
import ReactPaginate from "react-paginate";

function Pagination({
  pageCount,
  currentPage,
  onPageChange,
  currentItemsCount,
  totalItemsCount,
}) {
  if (pageCount <= 1) return null;

  return (
    <div className="mt-6">
      <ReactPaginate
        previousLabel="← Anterior"
        nextLabel="Siguiente →"
        pageCount={pageCount}
        onPageChange={(e) => onPageChange(e.selected)}
        forcePage={currentPage} // 🔥 sincroniza
        containerClassName="flex flex-wrap justify-center gap-1 px-2 sm:gap-2"
        pageClassName="cursor-pointer rounded-lg border px-2 py-2 sm:px-3"
        previousClassName="cursor-pointer rounded-lg border px-2 py-2 sm:px-3"
        nextClassName="cursor-pointer rounded-lg border px-2 py-2 sm:px-3"
        activeClassName="bg-blue-600 text-white"
        disabledClassName="opacity-50 cursor-not-allowed"
      />

      <p className="text-sm text-gray-500 mt-3 text-center">
        Mostrando {currentItemsCount} de {totalItemsCount} registros
      </p>
    </div>
  );
}

export default Pagination;
